'use client';

export { EmptyState as SettingsEmptyState, type EmptyStateProps as SettingsEmptyStateProps } from '~/components/EmptyState';
